import axios from 'axios';
import getEnv from '@/utils/env'

let baseURL = getEnv('VITE_APP_BACKEND_URL')
let apiBaseURL = `${baseURL}/api`
let userBaseURL = `${baseURL}/accounts`

const api = axios.create({
  baseURL: apiBaseURL,
  withCredentials: true
});

const userApi = axios.create({
  baseURL: userBaseURL,
  withCredentials: true
});

const handleSessionExpired = (error) => {
  if (
    error.response?.status === 403 &&
    !error.config.url.includes('logout/') &&
    window.location.pathname !== '/'
  ) {
    sessionStorage.removeItem('userRaw');
    window.location.href = '/?session_expired=true';
  }
  return Promise.reject(error);
};

api.interceptors.response.use(null, handleSessionExpired);
userApi.interceptors.response.use(null, handleSessionExpired);

const fetchCsrfToken = () => {
  return api.get('get-csrf-token/')
    .then(response => {
      const csrfToken = response.data.csrfToken;
      localStorage.setItem('csrfToken', csrfToken);
      api.defaults.headers.common['X-CSRFToken'] = csrfToken;
    })
    .catch(error => {
      console.error('Error fetching CSRF token:', error);
    });
};

fetchCsrfToken();

export { api, userApi };
